const scope = "fat";
export default scope;
